export const MAX_QUANTITY_VALUE = 238_609_294;
